import { FunctionComponent } from 'react';
import { Container, Text } from './styled';

export interface QuestStatusBadgeProps {
    text: string;
    color: string;
    backgroundColor: string;
}

const QuestStatusBadge: FunctionComponent<QuestStatusBadgeProps> = ({
    text,
    color,
    backgroundColor
}) => (
    <Container backgroundColor={backgroundColor}>
        <Text color={color}>{text}</Text>
    </Container>
);

export default QuestStatusBadge;
